import { Link } from "wouter";
import ServiceCard from "@/components/ServiceCard";
import TestimonialCarousel from "@/components/TestimonialCarousel";
import ProjectCard from "@/components/ProjectCard";
import { services } from "@/data/services";
import { projects } from "@/data/projects";
import { testimonials } from "@/data/testimonials";

const Home = () => {
  // Only show the first 3 services on the homepage
  const highlightedServices = services.slice(0, 3);
  // Only show the first 3 projects on the homepage
  const highlightedProjects = projects.slice(0, 3);

  return (
    <>
      {/* Hero Section */}
      <section 
        className="h-screen bg-cover bg-center flex items-center relative"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80')" }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 to-black/80"></div>
        <div className="container mx-auto px-4 z-10">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-3">
              <div className="mb-4 mt-4">
                <span className="text-white text-2xl md:text-3xl font-heading font-bold tracking-wider">V&M Group Ltd</span>
              </div>
              <h1 className="text-4xl md:text-6xl font-heading font-bold text-white mb-6 text-shadow leading-tight">
                Реализирайте Вашия проект<br />с професионалисти
              </h1>
              <p className="text-xl text-white mb-8 text-shadow max-w-xl">
                Нашият екип ще ви впечатли с добри цени, високо качество на довършителните работи и прецизно изпипване на всеки детайл
              </p>
              
              <div className="bg-primary/90 text-white p-6 rounded-lg mb-8 max-w-md backdrop-blur-sm">
                <div className="flex items-center mb-3">
                  <div className="w-8 h-8 rounded-full bg-[#FFC857] flex items-center justify-center text-primary mr-3">
                    <span className="font-bold">%</span>
                  </div>
                  <h3 className="text-xl font-heading font-bold">Актуални отстъпки и промоции</h3>
                </div>
                <p className="mb-4">При заявка на ремонти в районите на град София и София област.</p>
                <Link href="/contact">
                  <button className="w-full bg-[#D95204] hover:bg-opacity-90 text-white font-bold py-3 px-6 rounded-lg transition duration-300 flex items-center justify-center gap-2">
                    <span>ПОИСКАЙ ОФЕРТА</span>
                    <span className="text-lg">→</span>
                  </button>
                </Link>
              </div>
              
              <div className="flex justify-start">
                <Link href="tel:+359877338382" className="mr-6">
                  <button className="flex items-center text-white hover:text-[#FFC857] transition duration-300">
                    <span className="text-2xl mr-2">📞</span>
                    <span className="text-xl font-bold">087 733 8382</span>
                  </button>
                </Link>
              </div>
            </div>
            
            <div className="lg:col-span-2 hidden lg:block">
              <div className="bg-white/90 p-8 rounded-lg shadow-xl">
                <div className="flex justify-center mb-4">
                  <div className="flex items-center">
                    <span className="text-4xl font-bold text-primary">4.9</span>
                    <div className="flex ml-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <svg key={star} className="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-center text-sm text-gray-600 mb-4">от 143 завършени проекта</p>
                
                <div className="grid grid-cols-3 gap-4 mb-6">
                  <div className="text-center border border-gray-200 rounded p-3">
                    <div className="font-bold text-primary">5.0</div>
                    <div className="text-xs text-gray-600">Комуникация</div>
                  </div>
                  <div className="text-center border border-gray-200 rounded p-3">
                    <div className="font-bold text-primary">4.9</div>
                    <div className="text-xs text-gray-600">Качество</div>
                  </div>
                  <div className="text-center border border-gray-200 rounded p-3">
                    <div className="font-bold text-primary">4.9</div>
                    <div className="text-xs text-gray-600">Цена</div>
                  </div>
                </div>
                
                <Link href="/testimonials">
                  <button className="w-full bg-primary hover:bg-opacity-90 text-white font-bold py-3 px-6 rounded-lg transition duration-300">
                    Вижте отзивите
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        
        {/* Mobile Call Button */}
        <div className="lg:hidden fixed bottom-6 right-6 z-50">
          <Link href="tel:+359877338382">
            <button className="w-16 h-16 rounded-full bg-[#D95204] text-white flex items-center justify-center shadow-lg">
              <span className="text-2xl">📞</span>
            </button>
          </Link>
        </div>
      </section>

      {/* About Us / Values Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Нашите ценности</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Основните принципи, които ръководят работата ни и гарантират Вашето удовлетворение
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto mb-12">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-bold text-primary mb-2">Качество</h3>
              <p className="text-gray-700">
                Използваме само висококачествени материали и прилагаме най-добрите техники, за да постигнем отлични и дълготрайни резултати.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-bold text-primary mb-2">Професионализъм</h3>
              <p className="text-gray-700">
                Нашият екип от опитни специалисти работи с внимание към всеки детайл и се стреми към технически съвършени решения.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-bold text-primary mb-2">Надеждност</h3>
              <p className="text-gray-700">
                Спазваме стриктно сроковете и бюджета, като работим прозрачно и поддържаме ясна комуникация на всеки етап от проекта.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-heading font-bold text-primary mb-2">Иновация</h3>
              <p className="text-gray-700">
                Следим най-новите тенденции и технологии в бранша, за да предлагаме модерни и ефективни решения за вашите проекти.
              </p>
            </div>
          </div>
          
          <div className="bg-primary/10 rounded-lg p-8 text-center max-w-4xl mx-auto">
            <h3 className="text-2xl font-heading font-bold text-primary mb-4">
              Искате прецизно изпълнение и коректно отношение?
            </h3>
            <p className="mb-6 text-gray-700">
              Нашият екип от професионалисти ще изпълни вашия проект с най-високо качество, в срок и на конкурентна цена. 
              Свържете се с нас сега за безплатен оглед и индивидуална оферта.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link href="/contact">
                <button className="bg-[#D95204] hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-lg transition duration-300 flex items-center justify-center gap-2">
                  <span>ПОИСКАЙ ОФЕРТА</span>
                  <span className="text-lg">→</span>
                </button>
              </Link>
              <Link href="tel:+359877338382">
                <button className="bg-primary hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-lg transition duration-300 flex items-center justify-center gap-2">
                  <span className="text-lg">📞</span>
                  <span>087 733 8382</span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section Brief */}
      <section className="py-20 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Нашите услуги</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Предлагаме широк спектър от строителни и ремонтни услуги, изпълнени професионално и с внимание към детайла.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {highlightedServices.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
          
          <div className="text-center mt-12">
            <Link href="/services">
              <button className="inline-block bg-primary hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-lg transition duration-300">
                Вижте всички услуги
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Projects Section Brief */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Наши проекти</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Разгледайте някои от нашите завършени проекти и се убедете в качеството на нашата работа.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {highlightedProjects.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
          
          <div className="text-center mt-12">
            <Link href="/projects">
              <button className="inline-block bg-primary hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-lg transition duration-300">
                Разгледайте всички проекти
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Отзиви от клиенти</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Вижте какво казват нашите клиенти за работата ни.
            </p>
          </div>
          
          <TestimonialCarousel testimonials={testimonials} />
          
          <div className="text-center mt-12">
            <Link href="/testimonials">
              <button className="inline-block bg-primary hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-lg transition duration-300">
                Всички отзиви
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-heading font-bold mb-6">Готови ли сте да започнем вашия проект?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Свържете се с нас днес за безплатна консултация и оферта за вашия ремонт или строителен проект.
          </p>
          <Link href="/contact">
            <button className="bg-[#D95204] hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-lg transition duration-300 text-lg">
              Свържете се с нас
            </button>
          </Link>
        </div>
      </section>
    </>
  );
};

export default Home;
